var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconGuestOrUser = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.684 13.286a5.143 5.143 0 1 0 0-10.286 5.143 5.143 0 0 0 0 10.286zm-1.836 1.928a7.162 7.162 0 0 0-7.164 7.164c0 .66.534 1.193 1.193 1.193h15.614c.659 0 1.193-.534 1.193-1.193a7.162 7.162 0 0 0-7.164-7.164h-3.672z",
    fill: "#1A202C",
    fillRule: "nonzero"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconGuestOrUser, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-guest-or-user.b248d1a9.svg";
export { ForwardRef as ReactComponent };